module.exports = __webpack_public_path__ + "img/biker.23849529.png";